// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__skvCm","row":"Node_row__TJdpH","label":"Node_label__-T_-O","footer":"Node_footer__XkAQT"};